import { Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import CustomToastNotification from "../components/common/CustomToastNotification";
import FormField from "../components/common/FormField";
import contactImage from "../dist/images/contact.png";
import { createContactMessage } from "../redux/actions/contact_actions";

const ContactUs = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.contact_reducers.loading);

  const {
    reset,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (formData) => {
    const { fullname, email, message } = formData;

    const data = formData.phoneNumber
      ? formData
      : {
          fullname,
          email,
          message,
        };

    try {
      const response = await dispatch(createContactMessage(data));
      if (response) {
        toast.success(CustomToastNotification, {
          data: {
            title: "Success!",
            content: "Your message has been sent successfully!",
          },
          ariaLabel: "Success",
        });
        reset();
      }
    } catch (err) {
      const errorMessage =
        err.response?.data?.errors?.[0] || err.message || "An error occurred";
      toast.error(CustomToastNotification, {
        data: {
          title: "Failed!",
          content: errorMessage,
        },
        ariaLabel: "Failed",
        theme: "colored",
      });
    }
  };

  return (
    <div className="row min-height-50 px-3 py-5 contact-section page-height">
      <div className="col-lg-12">
        <div className="row m-0">
          <div className="col-lg-12">
            <h1 className="text-white px-3 py-1 pl-5 title ">Reach Out!</h1>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 p-0">
            <div className="">
              <p className="contact-email bg-light-blue pr-2 py-2 pl-5 br-5 font-20">
                hi5@fleetsimplify.com
              </p>
              <img
                src={contactImage}
                alt="customer care user"
                className="img-fluid d-block mt-5"
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="contact-form bg-light-blue p-2 br-5 px-lg-5 py-4">
              <Form onSubmit={handleSubmit(onSubmit)}>
                <h1 className="mb-4">Contact Us</h1>
                <FormField error={errors.fullname} controlId="fullname">
                  <Form.Control
                    type="text"
                    name="fullname"
                    placeholder="Your Name"
                    {...register("fullname", {
                      required: "Name is required",
                      setValueAs: (v) => v.trim(),
                    })}
                    className={`height-50 px-3 ${
                      errors.fullname ? "border-red" : "border-gray"
                    }`}
                  />
                </FormField>
                <FormField error={errors.email} controlId="email">
                  <Form.Control
                    type="email"
                    name="email"
                    placeholder="Your Email Address"
                    {...register("email", { required: "Email is required" })}
                    className={`height-50 px-3 ${
                      errors.email ? "border-red" : "border-gray"
                    }`}
                  />
                </FormField>
                <FormField error={errors.phoneNumber} controlId="phoneNumber">
                  <Form.Control
                    type="tel"
                    name="phoneNumber"
                    placeholder="Your Phone Number (Optional)"
                    {...register("phoneNumber")}
                    className="height-50 px-3"
                  />
                </FormField>
                <FormField error={errors.message} controlId="message">
                  <Form.Control
                    as="textarea"
                    name="message"
                    cols={3}
                    rows={3}
                    placeholder="Your Message"
                    {...register("message", {
                      required: "Message is required",
                      setValueAs: (v) => v.trim(),
                    })}
                    className={`px-3 ${
                      errors.message ? "border-red" : "border-gray"
                    }`}
                  />
                </FormField>
                <button 
                  type="submit" 
                  className="btn btn-blue br-10" 
                  disabled={isLoading}
                >
                  {isLoading ? "Sending..." : "Send Message"}
                </button>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
